
<ion-item  mode="ios" detail (click)="viewAction()" >
  <app-outlet-avatar 
  slot="start"
  [outlet]="outlet"
  ></app-outlet-avatar>
  <ion-label >
    <h2>{{outlet.name}}</h2>
    <p *ngIf="kmFromUser" style="
    overflow: hidden;
    text-overflow: ellipsis;">{{kmFromUser.toFixed(2)}}km - {{outlet.address}}</p>
    <p *ngIf="!kmFromUser" style="
    overflow: hidden;
    text-overflow: ellipsis;">{{outlet.address}}</p>
  </ion-label>
 </ion-item>
